export default __webpack_public_path__ + "static/media/Comp 2_00006.296da6e3.png";